"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function IconCard(_ref) {
  let {
    iconUrl,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "p-media-object u-no-margin--bottom",
    style: {
      height: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: iconUrl,
    width: 48,
    height: 48,
    alt: "",
    className: "p-media-object__image",
    "data-testid": "package-icon"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sc-package-card p-media-object__details",
    style: {
      width: "100%"
    }
  }, children));
}
var _default = exports.default = IconCard;